module.exports = __webpack_public_path__ + "static/media/f01b7f8c-22f9-4b50-9ad7-d3a17cf65b06.71ebbdfa.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/Fonts/f01b7f8c-22f9-4b50-9ad7-d3a17cf65b06.woff2
// module id = 104
// module chunks = 0